<template>
    <div class='maintainPage-container'>
        <div class='slide-nav'>
            <div class='logo'>
                <img src='../../../assets/img/dataDashboards.png'>
                <div class='text'>
                    <h3>动态数据看板</h3>
                    <span></span>
                    <h4>Dynamic data Kanban</h4>
                </div>
            </div>
            <ul>
                <li v-for='item in slideData' :key='item.value' :class='{pick:pick===item.value}'>{{ item.title }}</li>
            </ul>
        </div>
        <div class='content'>
            <div class='first'>
                <div>
                    <kLineChart ></kLineChart>
                </div>
                <div>
                    <LineChart title='国民经济运行情况' :macroType='4'></LineChart>
                </div>
            </div>
            <div class='other'>
                <LineChart title='新增信贷数据' :macroType='7'></LineChart>
            </div>
            <div class='other'>
                <LineChart  title='中国宏观杠杆率' :macroType='8'></LineChart>
            </div>
        </div>
    </div>
</template>
<script>
import kLineChart from './compontents/kLineChart';
import LineChart from './compontents/LineChart.vue';
import { slideData } from '@/components/page/maintainPage/data';

export default {
    components: {
        kLineChart,
        LineChart
    },
    data() {
        return {
            slideData: slideData,
            pick: 0
        };
    },
        created(){},
        methods:{},
    }
</script>
<style lang='scss' scoped>
.pick{
    background: rgb(226,233,255)!important;
    color: #0227A7!important;
}
    .maintainPage-container{
        display: flex;
        margin-top: 70px;
        border-bottom: 1px solid #efefef;
        .slide-nav{
            width: 340px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 20px;
            .logo{
                position: relative;
                img{
                    width: 300px;
                    height: 140px;
                }
                .text{
                    position: absolute;
                    left: 0;
                    top: 0;
                    color: #fff;
                    z-index: 999;
                    margin-top: 28px;
                    margin-left: 20px;
                    h3{
                        font-size: 24px;
                        font-family: Microsoft YaHei,serif;
                        font-weight: bold;
                        line-height: 31px;
                    }
                    h4{
                        font-size: 18px;
                        font-family: Microsoft YaHei,serif;
                    }
                    span{
                        display: block;
                        width: 44px;
                        height: 1px;
                        background: #fff;
                        margin-top: 8px;
                        margin-bottom: 14px;
                    }
                }
            }

            ul{
                margin-top:65px ;
                display: flex;
                flex-direction: column;
                align-items: center;
                li{
                    text-align: center;
                    width: 300px;
                    height: 60px;
                    font-size: 20px;
                    font-family: Microsoft YaHei,serif;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 40px;
                    line-height: 60px;
                    cursor: pointer;
                    &:hover{
                        background: rgb(226,233,255);
                        color: #0227A7;
                    }
                }
            }
        }
        .content{
            flex: 1;
            background: rgb(230,230,230);
            padding:20px  20px 68px;
            &>div{
                width: 80vw;
            }
            .first{
                height: 440px;
                display: flex;
                justify-content: space-between;
                background: transparent;
                div{
                    background: #fff;
                    width: 39vw;
                    border-radius: 10px;
                }
            }
            .other{
                background: #fff;
                margin-top: 20px;
                height: 440px;
                border-radius: 10px;
            }
        }
    }
</style>
